import { ErrorBoundary } from 'react-error-boundary';
import { useProduct } from '../ProductCard';

export const ProductImage: React.FC = () => {
  const product = useProduct();

  if (!product || !product.image) {
    return (
      <div
        data-testid="product-image"
        className={`
        tw-mx-auto tw-mb-1
        tw-mt-2 tw-h-[120px] tw-w-[120px] tw-animate-pulse
        tw-bg-black-200 tw-grid-area-[image] desktop:tw-h-[156px]
        desktop:tw-w-[156px]
        `}
      ></div>
    );
  }

  return (
    <ErrorBoundary
      fallbackRender={() => (
        <div
          data-testid="product-image"
          className={`
          tw-mx-auto
          tw-mb-1 tw-mt-2 tw-h-[120px] tw-w-[120px]
          tw-bg-black-200 tw-grid-area-[image] desktop:tw-h-[156px]
          desktop:tw-w-[156px]
          `}
        ></div>
      )}
      onError={(e) =>
        console.error('An error occurred while rendering the product image', {
          product,
          error: e,
        })
      }
    >
      <img
        data-testid="product-image"
        className={`
          tw-mx-auto
          !tw-mb-2 !tw-mt-2 tw-h-[120px] tw-w-[120px]
          tw-object-contain tw-grid-area-[image] desktop:tw-h-[156px] desktop:tw-w-[156px]
      `}
        src={`${product.image!}?width=312&quality=60`}
        alt={product.title}
        loading="lazy"
      />
    </ErrorBoundary>
  );
};

export const HorizontalProductImage = () => {
  const product = useProduct();

  if (!product) {
    return (
      <div
        data-testid="product-image"
        className={`
        tw-size-[56px]
        tw-bg-black-200 tw-grid-area-[image]
        `}
      ></div>
    );
  }

  return (
    <ErrorBoundary
      fallbackRender={() => (
        <div
          data-testid="product-image"
          className={`
          tw-size-[56px]
          tw-bg-black-200 tw-object-contain
        tw-grid-area-[image]
          `}
        ></div>
      )}
      onError={(e) =>
        console.error('An error occurred while rendering the product image', {
          product,
          error: e,
        })
      }
    >
      <img
        data-testid="product-image"
        className={`
            tw-size-[56px]
            tw-object-contain
            tw-grid-area-[image]
        `}
        src={`${product.image!}?width=312&quality=60`}
        alt={product.title}
      />
    </ErrorBoundary>
  );
};
